<div [className]="contentClass">
    <div class="contex-html" [innerHTML]="html | safehtml"></div>
</div>
